<script setup lang="ts">
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/20/solid";

defineProps<{ value: boolean }>();
</script>

<template>
  <span>
    <template v-if="value">
      <CheckCircleIcon class="w-5 h-5 text-green-600" />
    </template>
    <template v-else>
      <XCircleIcon class="w-5 h-5 text-red-600" />
    </template>
  </span>
</template>
